import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
import Navbar from '../components/navbar'
import ContactModal from '../components/contact-modal'
import Mark from '../components/mark'
import FAQ from '../components/faq'
import Footer from '../components/footer'
import './home.css'

const SocialRecruitingBeratung = () => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false)
  const [buttonSource, setButtonSource] = useState('')

  const openContactModal = (source = 'Unbekannt') => {
    setButtonSource(source)
    setIsContactModalOpen(true)
  }

  const closeContactModal = () => {
    setIsContactModalOpen(false)
  }

  return (
    <div className="home-container1">
      <Helmet>
        <title>Social Recruiting Beratung Berlin | Strategische Recruiting Beratung für Ihr Unternehmen</title>
        <meta name="description" content="Professionelle Social Recruiting Beratung in Berlin: Strategische Beratung für erfolgreiche Mitarbeitergewinnung über Social Media. Nutzen Sie unsere Expertise für Ihr digitales Recruiting." />
        <meta property="og:title" content="Social Recruiting Beratung Berlin | Strategische Recruiting Beratung" />
        <meta property="og:description" content="Ihre Experten für Social Recruiting Beratung in Berlin. Wir entwickeln maßgeschneiderte Strategien für erfolgreiche Mitarbeitergewinnung über Social Media." />
      </Helmet>
      
      <Navbar rootClassName="navbarroot-class-name" onContactClick={openContactModal}></Navbar>

      <section className="home-section10">
        <div className="home-hero">
          <div className="home-content1">
            <main className="home-main1">
              <header className="home-header10" >
                <h1 className="home-heading10">
                  Social Recruiting Beratung: Ihre Experten für strategische Mitarbeitergewinnung in Berlin
                </h1>
                <span className="home-caption1">
                  Als spezialisierte Social Recruiting Agentur in Berlin bieten wir umfassende Beratung für Ihr digitales Recruiting. Von der Strategie-Entwicklung bis zur Umsetzung – wir begleiten Sie auf dem Weg zum erfolgreichen Social Media Recruiting und helfen Ihnen, qualifizierte Fachkräfte zu finden.
                </span>
              </header>
              <div className="home-buttons1">
                <div className="home-get-started1 button" onClick={() => openContactModal('Kostenlose Beratung')} style={{ cursor: 'pointer' }}>
                  <span className="home-text10">Kostenlose Erstberatung</span>
                </div>
              </div>
            </main>
          </div>
          <div className="home-image13">
            <img
              alt="Social Recruiting Beratung Berlin"
              src="/social-media-recruiting-agentur-hero.png"
              className="home-image14"
            />
          </div>
        </div>
      </section>

      <section className="home-section11" style={{ marginTop: '80px' }}>
        <h2 className="home-text12">
          Warum professionelle Social Recruiting Beratung der Schlüssel zu Ihrem Erfolg ist
        </h2>
        <div className="home-note1">
          <div className="home-content2">
            <main className="home-main2">
              <h2 className="home-heading11">
                Was ist Social Recruiting Beratung und warum brauchen Unternehmen strategische Unterstützung?
              </h2>
              <p className="home-paragraph1">
                <span>
                  Social Recruiting Beratung ist weit mehr als nur Tipps für Ihre Social Media Präsenz. Es geht um die strategische Entwicklung eines ganzheitlichen Ansatzes für die digitale Mitarbeitergewinnung. Als spezialisierte Social Recruiting Agentur in Berlin verstehen wir, dass jedes Unternehmen einzigartig ist – mit individuellen Herausforderungen, spezifischen Zielgruppen und unterschiedlichen Ressourcen. Unsere Beratung setzt genau hier an.
                </span>
                <br></br>
                <br></br>
                <span>
                  Der Fachkräftemangel betrifft heute nahezu jede Branche, besonders stark jedoch den Mittelstand und spezialisierte Fachbereiche. Traditionelle Recruiting-Methoden stoßen an ihre Grenzen – Stellenanzeigen auf Jobbörsen erreichen oft nicht die richtigen Kandidaten, und passive Talente, die nicht aktiv auf Job-Suche sind, werden gar nicht erst angesprochen. Hier liegt die Stärke von Social Recruiting: Die gezielte Ansprache potenzieller Bewerber dort, wo sie ihre Zeit verbringen – auf Social Media Plattformen wie LinkedIn, Facebook und Instagram.
                </span>
                <br></br>
                <br></br>
                <span>
                  Unsere Social Recruiting Beratung in Berlin beginnt mit einer umfassenden Analyse Ihrer aktuellen Recruiting-Situation. Wir analysieren Ihre Zielgruppe, Ihre Arbeitgebermarke, Ihre bisherigen Recruiting-Kanäle und Ihre Wettbewerbssituation. Darauf aufbauend entwickeln wir eine maßgeschneiderte Social Media Recruiting Strategie, die perfekt zu Ihrem Unternehmen passt. Dabei berücksichtigen wir nicht nur die Auswahl der richtigen Plattformen, sondern auch Content-Strategien, Targeting-Möglichkeiten, Budget-Allokation und Erfolgsmessung.
                </span>
                <br></br>
                <br></br>
                <span>
                  Die professionelle Beratung durch eine erfahrene Social Recruiting Agentur spart Ihnen wertvolle Zeit und Ressourcen. Statt durch Trial-and-Error zu lernen, profitieren Sie von unserem umfangreichen Know-how und Best Practices aus hunderten erfolgreichen Projekten. Wir wissen, welche Social Recruiting Maßnahmen funktionieren, welche Fehler Sie vermeiden sollten und wie Sie Ihr Budget optimal einsetzen, um qualifizierte Bewerbungen zu generieren.
                </span>
              </p>
            </main>
            <div className="home-explore-more" onClick={() => openContactModal('Beratungsgespräch vereinbaren')} style={{ cursor: 'pointer' }}>
              <p className="home-text24">Beratungsgespräch vereinbaren →</p>
            </div>
          </div>
          <div className="home-image17">
            <img
              alt="Social Recruiting Strategie"
              src="/social-media-recruiting-agentur-zusammenwirken.png"
              className="home-image18"
            />
          </div>
        </div>
      </section>

      <section className="home-section12">
        <header className="home-header11">
          <h2 className="home-text25">Die wichtigsten Elemente unserer Social Recruiting Beratung</h2>
          <span className="home-text26">
            Als erfahrene Social Recruiting Agentur in Berlin decken wir alle Aspekte des erfolgreichen Social Media Recruitings ab – von der Strategie bis zur operativen Umsetzung.
          </span>
        </header>
        
        <section className="home-note2">
          <div className="home-image19">
            <img
              alt="Strategieentwicklung Social Recruiting"
              src="/social-media-recruiting-agentur-funktion.png"
              className="home-image20"
            />
          </div>
          <div className="home-content3">
            <div className="home-main3">
              <div className="home-caption3">
                <span className="section-head">Strategieentwicklung</span>
              </div>
              <div className="home-heading12">
                <h2 className="section-heading">
                  Individuelle Social Recruiting Strategie für Ihr Unternehmen
                </h2>
                <p className="section-description">
                  Die Basis jedes erfolgreichen Social Recruitings ist eine durchdachte Strategie. In unserer Beratung entwickeln wir gemeinsam mit Ihnen einen maßgeschneiderten Ansatz, der zu Ihren Zielen, Ihrer Zielgruppe und Ihrem Budget passt. Wir definieren klare KPIs, identifizieren die richtigen Social Media Kanäle und legen fest, welche Content-Formate und Recruiting Ads am besten geeignet sind, um Ihre Wunschkandidaten zu erreichen.
                  
                  Besonders wichtig ist die Analyse Ihrer Zielgruppe: Wo bewegen sich potenzielle Bewerber online? Welche Inhalte sprechen sie an? Wie erreichen Sie passive Kandidaten, die nicht aktiv auf Job-Suche sind? Als Social Recruiting Agentur mit Sitz in Berlin bringen wir umfangreiche Erfahrung aus verschiedensten Branchen mit – vom Mittelstand über Startups bis zu Großunternehmen. Diese Expertise fließt in Ihre individuelle Strategie ein.
                  
                  Ein weiterer Kernaspekt unserer Beratung ist die Integration von Social Recruiting in Ihre bestehenden HR-Prozesse. Wir zeigen Ihnen, wie Sie Social Media Recruiting nahtlos in Ihren Recruiting-Funnel einbinden, wie Sie Bewerbungsprozesse optimieren und wie Sie durch gezieltes Personalmarketing Ihre Arbeitgebermarke stärken. Dabei berücksichtigen wir auch technische Aspekte wie Tracking, Conversion-Optimierung und die Anbindung an Ihr Bewerbermanagementsystem.
                </p>
              </div>
            </div>
            <div className="home-get-started3 button" onClick={() => openContactModal('Strategie entwickeln')} style={{ cursor: 'pointer' }}>
              <span className="home-text27">Strategie entwickeln lassen</span>
            </div>
          </div>
        </section>

        <section className="home-note3">
          <div className="home-image21">
            <img
              alt="Employer Branding Beratung"
              src="/social-media-recruiting-agentur-erfolg.png"
              className="home-image22"
            />
          </div>
          <div className="home-content4">
            <main className="home-main4">
              <header className="home-caption4">
                <span className="home-section14 section-head">
                  Employer Branding Integration
                </span>
              </header>
              <main className="home-heading14">
                <header className="home-header12">
                  <h2 className="section-heading">
                    Wie Employer Branding Ihr Social Recruiting zum Erfolg führt
                  </h2>
                  <p className="section-description">
                    Erfolgreiches Social Recruiting beginnt mit einer starken Arbeitgebermarke. In unserer Beratung analysieren wir Ihre aktuelle Arbeitgebermarke und entwickeln Strategien, um diese über Social Media zu stärken. Wir zeigen Ihnen, wie Sie Ihre Unternehmenskultur authentisch kommunizieren, Mitarbeiter als Markenbotschafter einsetzen und Content kreieren, der potenzielle Bewerber begeistert.
                    
                    Eine professionelle Social Recruiting Agentur weiß: Employer Branding ist kein Nice-to-have, sondern die Grundlage für erfolgreiches Recruiting. Kandidaten informieren sich heute umfassend über potenzielle Arbeitgeber, bevor sie sich bewerben. Ihre Präsenz auf Social Media, die Inhalte, die Sie teilen, und die Art, wie Sie mit Ihrer Community interagieren, prägen die Wahrnehmung Ihrer Arbeitgebermarke maßgeblich. Wir helfen Ihnen, diese Touchpoints gezielt zu gestalten und eine konsistente, überzeugende Botschaft zu vermitteln.
                  </p>
                </header>
                <div className="home-checkmarks">
                  <Mark label="Authentische Darstellung Ihrer Unternehmenskultur"></Mark>
                  <Mark label="Mitarbeiter-Testimonials und Employee Advocacy"></Mark>
                  <Mark label="Content-Strategien für nachhaltige Arbeitgebermarke"></Mark>
                </div>
              </main>
            </main>
            <div className="home-get-started4 button" onClick={() => openContactModal('Employer Branding Beratung')} style={{ cursor: 'pointer' }}>
              <span className="home-text28">Employer Branding Beratung</span>
            </div>
          </div>
        </section>
      </section>

      <section className="home-section11">
        <h2 className="home-text12">
          Social Recruiting Beratung für den Mittelstand: Spezifische Lösungen für besondere Herausforderungen
        </h2>
        <div className="home-note1">
          <div className="home-content2">
            <main className="home-main2">
              <h2 className="home-heading11">
                Wie mittelständische Unternehmen von strategischer Social Recruiting Beratung profitieren
              </h2>
              <p className="home-paragraph1">
                <span>
                  Der Mittelstand steht beim Recruiting vor besonderen Herausforderungen: Begrenzte Budgets, weniger Bekanntheit als Großkonzerne und oft fehlendes internes Know-how für digitales Recruiting. Gleichzeitig ist der Fachkräftemangel hier besonders spürbar. Unsere Social Recruiting Beratung ist speziell auf die Bedürfnisse mittelständischer Unternehmen ausgerichtet.
                </span>
                <br></br>
                <br></br>
                <span>
                  Als Social Recruiting Agentur in Berlin verstehen wir die Situation des Mittelstands genau. Sie benötigen effiziente, kosteneffektive Lösungen, die schnell Ergebnisse liefern – ohne dass Sie eine eigene Social-Media-Abteilung aufbauen müssen. In unserer Beratung zeigen wir Ihnen, wie Sie Social Media Recruiting gezielt einsetzen, um qualifizierte Fachkräfte zu erreichen, auch wenn Sie nicht über die Marketing-Budgets großer Konzerne verfügen.
                </span>
                <br></br>
                <br></br>
                <span>
                  Ein wichtiger Aspekt unserer Beratung für den Mittelstand ist die Effizienzoptimierung. Wir helfen Ihnen, Ihr Recruiting-Budget optimal einzusetzen: Welche Social Media Plattformen bringen den besten ROI für Ihre Zielgruppe? Wie können Sie durch gezieltes Targeting Streuverluste minimieren? Welche Content-Formate sind effektiv, ohne zu aufwendig in der Produktion zu sein? Unsere Expertise als Social Recruiting Agentur ermöglicht es Ihnen, von Anfang an die richtigen Entscheidungen zu treffen.
                </span>
                <br></br>
                <br></br>
                <span>
                  Besonders wertvoll für mittelständische Unternehmen ist unsere Unterstützung beim Aufbau interner Kompetenzen. Durch unsere Beratung lernt Ihr HR-Team die Grundlagen des Social Media Recruitings und kann nach der Implementierungsphase eigenständig weiterarbeiten. Wir bieten Workshops, Trainings und kontinuierlichen Support, damit Sie langfristig von Social Recruiting profitieren – auch über unsere direkte Zusammenarbeit hinaus.
                </span>
                <br></br>
                <br></br>
                <span>
                  Die Zusammenarbeit mit einer spezialisierten Social Recruiting Agentur ermöglicht es mittelständischen Unternehmen, sich im Wettbewerb um Talente zu behaupten. Sie erhalten Zugang zu Expertise, Tools und Best Practices, die sonst nur großen Unternehmen vorbehalten wären. Dabei behalten Sie die Kontrolle über Ihre Recruiting-Aktivitäten und können flexibel auf Veränderungen reagieren.
                </span>
              </p>
            </main>
            <div className="home-explore-more" onClick={() => openContactModal('Mittelstands-Beratung anfragen')} style={{ cursor: 'pointer' }}>
              <p className="home-text24">Mittelstands-Beratung anfragen →</p>
            </div>
          </div>
          <div className="home-image17">
            <img
              alt="Social Recruiting Mittelstand"
              src="/social-media-recruiting-agentur-mittelstand.png"
              className="home-image18"
            />
          </div>
        </div>
      </section>

      <section className="home-section12">
        <header className="home-header11">
          <h2 className="home-text25">Beratungsleistungen im Detail: Was Sie von unserer Social Recruiting Beratung erwarten können</h2>
          <span className="home-text26">
            Als ganzheitliche Social Recruiting Agentur in Berlin bieten wir umfassende Beratungsleistungen für alle Aspekte Ihres digitalen Recruitings.
          </span>
        </header>
        
        <section className="home-note2">
          <div className="home-image19">
            <img
              alt="Plattform-Beratung Social Media"
              src="/social-media-recruiting-agentur-linkedin.png"
              className="home-image20"
            />
          </div>
          <div className="home-content3">
            <div className="home-main3">
              <div className="home-caption3">
                <span className="section-head">Plattform-Auswahl & Optimierung</span>
              </div>
              <div className="home-heading12">
                <h2 className="section-heading">
                  Die richtigen Social Media Kanäle für Ihr Recruiting identifizieren
                </h2>
                <p className="section-description">
                  Nicht jede Social Media Plattform eignet sich gleich gut für jede Zielgruppe. LinkedIn ist ideal für Fach- und Führungskräfte im B2B-Bereich, Facebook erreicht eine breite demografische Gruppe und ist besonders effektiv für lokales Recruiting, während Instagram und TikTok jüngere Zielgruppen ansprechen. In unserer Beratung analysieren wir, welche Plattformen für Ihre spezifischen Anforderungen am besten geeignet sind.
                  
                  Wir beraten Sie zur optimalen Nutzung jeder Plattform: Wie gestalten Sie Ihre Unternehmensseite auf LinkedIn, um Fachkräfte anzusprechen? Welche Content-Formate funktionieren auf Instagram am besten für Employer Branding? Wie nutzen Sie Facebook-Gruppen für gezieltes Recruiting? Als erfahrene Social Recruiting Agentur kennen wir die Besonderheiten und Best Practices jeder Plattform und helfen Ihnen, diese optimal zu nutzen.
                  
                  Ein wichtiger Teil unserer Plattform-Beratung ist auch die Analyse Ihrer Wettbewerber: Wie präsentieren sich andere Arbeitgeber in Ihrer Branche auf Social Media? Welche Strategien sind erfolgreich? Wo liegen Chancen, sich zu differenzieren? Diese Insights fließen in Ihre individuelle Social Media Recruiting Strategie ein und helfen Ihnen, sich als attraktiver Arbeitgeber zu positionieren.
                </p>
              </div>
            </div>
            <div className="home-get-started3 button" onClick={() => openContactModal('Plattform-Beratung anfragen')} style={{ cursor: 'pointer' }}>
              <span className="home-text27">Plattform-Beratung anfragen</span>
            </div>
          </div>
        </section>

        <section className="home-note3">
          <div className="home-image21">
            <img
              alt="Content-Strategie Beratung"
              src="/social-media-recruiting-agentur-content.png"
              className="home-image22"
            />
          </div>
          <div className="home-content4">
            <main className="home-main4">
              <header className="home-caption4">
                <span className="home-section14 section-head">
                  Content & Kampagnen-Beratung
                </span>
              </header>
              <main className="home-heading14">
                <header className="home-header12">
                  <h2 className="section-heading">
                    Recruiting Content, der Kandidaten begeistert und Bewerbungen generiert
                  </h2>
                  <p className="section-description">
                    Traditionelle Stellenanzeigen funktionieren auf Social Media nicht. Erfolgreiches Social Recruiting erfordert Content, der unterhält, informiert und authentisch ist. In unserer Beratung entwickeln wir Content-Strategien, die zu Ihrer Arbeitgebermarke passen und Ihre Zielgruppe ansprechen. Von Mitarbeiter-Testimonials über Behind-the-Scenes-Videos bis zu informativen Karriere-Posts – wir zeigen Ihnen, welche Formate für Ihre Zwecke am besten geeignet sind.
                    
                    Als Social Recruiting Agentur wissen wir: Content-Erstellung muss nicht zwingend aufwendig sein. Auch mit begrenzten Ressourcen lassen sich authentische, wirkungsvolle Inhalte kreieren. Wir beraten Sie zu effizienten Produktionsprozessen, zum Einsatz von User-Generated Content und zur Aktivierung Ihrer Mitarbeiter als Content-Creators. Authentizität schlägt oft Hochglanz-Produktion – und ist gleichzeitig kostengünstiger.
                    
                    Ein weiterer wichtiger Bereich unserer Beratung sind Recruiting Ads auf Social Media. Wir zeigen Ihnen, wie Sie bezahlte Kampagnen effektiv einsetzen: Welche Targeting-Optionen sind für Ihre Zielgruppe relevant? Wie gestalten Sie Anzeigen, die hohe Click-Through-Raten erzielen? Wie optimieren Sie Ihre Ads kontinuierlich für bessere Ergebnisse? Durch datengetriebenes Testing und Optimierung helfen wir Ihnen, das Maximum aus Ihrem Werbebudget herauszuholen.
                  </p>
                </header>
                <div className="home-checkmarks">
                  <Mark label="Entwicklung authentischer Content-Strategien"></Mark>
                  <Mark label="Beratung zu effizienten Produktionsprozessen"></Mark>
                  <Mark label="Optimierung von Recruiting Ads für maximalen ROI"></Mark>
                </div>
              </main>
            </main>
            <div className="home-get-started4 button" onClick={() => openContactModal('Content-Beratung anfragen')} style={{ cursor: 'pointer' }}>
              <span className="home-text28">Content-Beratung anfragen</span>
            </div>
          </div>
        </section>
      </section>

      <section className="home-section15">
        <header className="home-header13">
          <header className="home-left1">
            <span className="section-head">Unsere Beratungs-Expertise</span>
            <h2 className="section-heading">
              <span>Warum Unternehmen aus Berlin und ganz Deutschland</span>
              <br></br>
              <span>auf unsere Social Recruiting Beratung vertrauen</span>
            </h2>
          </header>
          <div className="home-right1">
            <p className="home-paragraph4 section-description">
              Als spezialisierte Social Recruiting Agentur in Berlin bringen wir die perfekte Kombination aus Recruiting-Expertise, Social-Media-Know-how und strategischem Denken mit. Unsere Beratung basiert auf nachweisbaren Erfolgen und aktuellen Best Practices.
            </p>
          </div>
        </header>
      </section>

      <section className="home-section11">
        <h2 className="home-text12">
          Der Ablauf unserer Social Recruiting Beratung: Von der Analyse zur erfolgreichen Umsetzung
        </h2>
        <div className="home-note1">
          <div className="home-content2">
            <main className="home-main2">
              <h2 className="home-heading11">
                Wie funktioniert die Zusammenarbeit mit unserer Social Recruiting Agentur?
              </h2>
              <p className="home-paragraph1">
                <span>
                  <strong>Phase 1: Analyse & Strategie-Entwicklung</strong><br/>
                  Unsere Beratung beginnt mit einer umfassenden Analyse Ihrer aktuellen Situation. Wir evaluieren Ihre bisherigen Recruiting-Aktivitäten, analysieren Ihre Zielgruppe und Wettbewerber und identifizieren Chancen für Social Media Recruiting. Darauf aufbauend entwickeln wir eine maßgeschneiderte Strategie, die zu Ihren Zielen, Ihrer Arbeitgebermarke und Ihrem Budget passt. Diese Phase umfasst auch die Definition klarer KPIs und Erfolgskriterien.
                </span>
                <br></br>
                <br></br>
                <span>
                  <strong>Phase 2: Implementierung & Setup</strong><br/>
                  Nach der Strategie-Entwicklung unterstützen wir Sie bei der praktischen Umsetzung. Dies umfasst die Optimierung Ihrer Social Media Profile, die Einrichtung von Tracking und Analytics, die Entwicklung von Content-Templates und die Schulung Ihres Teams. Als erfahrene Social Recruiting Agentur stellen wir sicher, dass alle technischen und organisatorischen Voraussetzungen für erfolgreiches Social Recruiting geschaffen werden.
                </span>
                <br></br>
                <br></br>
                <span>
                  <strong>Phase 3: Kampagnen-Launch & Optimierung</strong><br/>
                  Wenn die Grundlagen stehen, starten wir mit den ersten Recruiting-Kampagnen. Wir begleiten Sie eng bei der Umsetzung, monitoren die Performance kontinuierlich und optimieren laufend. Durch datengetriebene Analysen identifizieren wir schnell, was funktioniert und was nicht, und passen die Strategie entsprechend an. Unser Ziel: Kontinuierliche Verbesserung der Recruiting-Ergebnisse.
                </span>
                <br></br>
                <br></br>
                <span>
                  <strong>Phase 4: Skalierung & Weiterentwicklung</strong><br/>
                  Sobald erste Erfolge sichtbar sind, arbeiten wir an der Skalierung Ihrer Social Recruiting Aktivitäten. Wir identifizieren weitere Potenziale, testen neue Kanäle und Formate und entwickeln Ihre Strategie kontinuierlich weiter. Gleichzeitig befähigen wir Ihr Team, zunehmend eigenständig zu arbeiten, sodass Sie langfristig unabhängig werden.
                </span>
                <br></br>
                <br></br>
                <span>
                  Die Dauer und Intensität unserer Beratung passen wir flexibel an Ihre Bedürfnisse an. Von einer initialen Strategieberatung über die vollständige Implementierungs-Begleitung bis zum kontinuierlichen Sparring – als Ihre Social Recruiting Agentur in Berlin sind wir genau so lange an Ihrer Seite, wie Sie uns brauchen.
                </span>
              </p>
            </main>
            <div className="home-explore-more" onClick={() => openContactModal('Beratungsprozess besprechen')} style={{ cursor: 'pointer' }}>
              <p className="home-text24">Beratungsprozess besprechen →</p>
            </div>
          </div>
          <div className="home-image17">
            <img
              alt="Social Recruiting Beratungsprozess"
              src="/social-media-recruiting-agentur-gezielt.png"
              className="home-image18"
            />
          </div>
        </div>
      </section>

      <section className="home-section19">
        <div className="home-cube1">
          <div className="home-top1 side"></div>
          <div className="home-front1 side"></div>
          <div className="home-left2 side"></div>
        </div>
        <main className="home-banner">
          <div className="home-header15">
            <h2 className="section-heading">
              Starten Sie jetzt mit professioneller Social Recruiting Beratung
            </h2>
            <p className="home-description1 section-description">
              Lassen Sie uns gemeinsam Ihre Social Media Recruiting Strategie entwickeln und qualifizierte Fachkräfte für Ihr Unternehmen gewinnen!
            </p>
          </div>
          <div className="home-buttons2">
            <div className="home-get-started5 button" onClick={() => openContactModal('Kostenlose Beratung buchen')} style={{ cursor: 'pointer' }}>
              <span className="home-text32">Kostenlose Beratung buchen</span>
            </div>
          </div>
        </main>
      </section>

      <section className="home-section26">
        <header className="home-header22">
          <span className="section-head">FAQ</span>
          <h2 className="home-heading26 section-heading">
            Häufig gestellte Fragen zur Social Recruiting Beratung
          </h2>
        </header>
        <main className="home-accordion">
          <FAQ rootClassName="fa-qroot-class-name"></FAQ>
        </main>
      </section>

      <section className="home-section28">
        <main className="home-content6">
          <header className="home-header23">
            <h2 className="home-heading27 section-heading">
              Bereit für strategische Social Recruiting Beratung? Kontaktieren Sie uns!
            </h2>
            <div className="home-buttons3">
              <div className="home-ios button" onClick={() => openContactModal('Jetzt Beratung anfragen')} style={{ cursor: 'pointer' }}>
                <span className="home-text50">Jetzt Beratung anfragen</span>
              </div>
            </div>
          </header>
          <img
            alt="Social Recruiting Beratung Berlin"
            src="/social-media-recruiting-agentur-bereit.png"
            className="home-image25"
          />
        </main>
      </section>

      <Footer activePage="social-recruiting-beratung" />

      <ContactModal isOpen={isContactModalOpen} onClose={closeContactModal} buttonSource={buttonSource} />
    </div>
  )
}

export default SocialRecruitingBeratung
